module.exports = __webpack_public_path__ + "static/facebook-logo-1da1f4c7af14206de84ef932e1a7dd7b.png";